import LeadSaga from "./saga";
import LeadOperationsSaga from "./lead-operations.saga";
import commonOperationSaga from "./common.saga";

export default [LeadSaga, LeadOperationsSaga, commonOperationSaga];
